import { observer } from 'mobx-react-lite'
import { AutomationLogResultStatusConfig } from 'entities/Integrations/ui/AutomationLogResultStatus'
import { type IAutomationLogExecutionStatus } from 'entities/Integrations'
import type { IWidgetProps } from 'widgets/FilterEditor/types/types'
import { WidgetStatus } from 'widgets/FilterEditor/ui/Widget/WidgetStatus'

export const WidgetAutomationLogResultStatus = observer((props: IWidgetProps) => {
  return (
    <WidgetStatus
      getConfigByStatus={(status) =>
        AutomationLogResultStatusConfig({ failedReason: 'failedReason' })[
          status as IAutomationLogExecutionStatus
        ]
      }
      {...props}
    />
  )
})
